import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SelectModule } from '@cmps/ng-select';
import {
    CmpsButtonModule,
    CmpsContainerModule,
    CmpsIconModule,
    CmpsTooltipModule,
} from '@cmps/ng-uikit';

import { CmpsCommonModule } from '../../common/common.module';
import { CmpsLazyI18nModule } from '../../i18n/i18n.module';
import { Widgets } from '../../widget/widget.model';
import { CmpsWidgetModule } from '../../widget/widget.module';
import { ScorecardDataService } from '../core/data.service';
import { ExperimentalNgGridModule } from '../experimental.grid';

import { ScorecardWidgetComponent } from './pulse-widget.component';
import { TranslationIdMap } from './pulse-widget.i18n';
import { SwDetailComponent } from './pw-detail/pw-detail.component';
import { ScBonusWidgetComponent } from './sub-widget/bonus/bonus-pulse-widget.component';
import { ScOverallPulseWidgetComponent } from './sub-widget/overall/overall-pulse-widget.component';
import { ScRanksPulseWidgetComponent } from './sub-widget/rank/ranks-pulse-widget.component';
import { ScYourTeamWidgetComponent } from './sub-widget/your-team/yourteam-pulse-widget.component';

const ModuleWidgets: Widgets = [
    { typeId: 27, component: ScorecardWidgetComponent, noEncapsulate: true },
];

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        HttpClientModule,
        CmpsCommonModule,
        CmpsIconModule,
        CmpsContainerModule,
        CmpsWidgetModule.forChild(ModuleWidgets),
        CmpsContainerModule,
        CmpsLazyI18nModule.forChild(TranslationIdMap),
        CmpsButtonModule,
        CmpsTooltipModule,
        SelectModule,
        FormsModule,
        ExperimentalNgGridModule,
    ],
    declarations: [
        SwDetailComponent,
        ScRanksPulseWidgetComponent,
        ScBonusWidgetComponent,
        ScOverallPulseWidgetComponent,
        ScYourTeamWidgetComponent,
        ScorecardWidgetComponent,
    ],
    providers: [ScorecardDataService],
})
export class CmpsScorecardWidgetModule {}
